function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import _map from 'lodash/map';
import _filter from 'lodash/filter';
import React from 'react';
import PropTypes from 'prop-types';
import SelectedGenerators from 'js/containers/legacy/SelectedGenerators';
var SELECT_SOURCES_TEXT = 'Select Sources';

var SelectedGeneratorsMobile =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectedGeneratorsMobile, _React$Component);

  function SelectedGeneratorsMobile(props) {
    var _this;

    _classCallCheck(this, SelectedGeneratorsMobile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectedGeneratorsMobile).call(this, props));
    _this._launchModal = _this._launchModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(SelectedGeneratorsMobile, [{
    key: "_launchModal",
    value: function _launchModal() {
      this.props.openSelectSourcesModal({
        content: {
          title: React.createElement(SelectedGenerators, {
            plotId: this.props.plotId
          }),
          plotClearGenerators: this.props.plotClearGenerators
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "col-xs-12"
      }, React.createElement("div", {
        className: "panel panel-default clearfix data-page__section__download-data-panel"
      }, React.createElement("div", {
        className: "panel-body"
      }, this.props.children ? React.createElement("div", {
        className: "selected-generators"
      }, this.props.children) : null, React.createElement("div", {
        className: "selected-generators"
      }, _map(_filter(this.props.plotGenerators, 'selected'), function (generator) {
        return React.createElement("span", {
          className: "label label-default",
          key: "selected-generator-".concat(generator.id),
          style: {
            backgroundColor: generator.color
          }
        }, generator.title);
      })), React.createElement("div", {
        className: "selected-generators"
      }, React.createElement("button", {
        className: "btn btn-primary",
        onClick: this._launchModal
      }, React.createElement("span", {
        className: "glyphicon glyphicon-hand-up"
      }), React.createElement("span", {
        className: "text"
      }, " ".concat(SELECT_SOURCES_TEXT)))))));
    }
  }]);

  return SelectedGeneratorsMobile;
}(React.Component);

SelectedGeneratorsMobile.propTypes = {
  plotGenerators: PropTypes.object.isRequired,
  plotId: PropTypes.string.isRequired,
  openSelectSourcesModal: PropTypes.func.isRequired,
  plotClearGenerators: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
  children: PropTypes.node
};
export { SelectedGeneratorsMobile as default };